import { FeatureFlagEnums } from "./featureFlags.type"

export interface BreakPolicy {
	shiftHours: number
	breakHours: number
}

export interface PayBillCodeRules {
	bankHolidayMultiplier: number
	isBreakUnpaid: boolean
	breakPolicy?: BreakPolicy[]
}

export interface PBCodeInterface {
	name: string
	description: string
	ratePerHour: number
	usedFor: string
	type: string
	rules: PayBillCodeRules
	isActive: boolean
}

export interface GetPBCodeInterface extends PBCodeInterface {
	_id: string
}

export interface UpdatePBCodeInterface extends PBCodeInterface {
	_id: string
}

export interface PBRulesInterface {
	name: string
	description: string
	startDate: string
	rate: number
	fixedHours: number
	externalCode: string
	hoursType: string
	PBCode: string
	rateType: string
	ruleText: string
	applicableDays: {
		monday: boolean
		tuesday: boolean
		wednesday: boolean
		thursday: boolean
		friday: boolean
		saturday: boolean
		sunday: boolean
	}
	from: number
	to: number
	activateRuleHours: number
	isForBilling: boolean
	requiresApproval: boolean
	causesCheckFailure: boolean
	useGreatestAmount: boolean
	type: string
}

export interface GetPBRulesInterface extends PBRulesInterface {
	_id: string
}

export interface UpdatePBRulesInterface extends PBRulesInterface {
	_id: string
}

export interface PBRuleDetailsInterface {
	PBRule: string
	startDate: string
	rate: number
	fixedHours: number
	externalCode: string
	hoursType: string
	PBCode: string
	rateType: string
	ruleText: string
	applicableDays: {
		monday: boolean
		tuesday: boolean
		wednesday: boolean
		thursday: boolean
		friday: boolean
		saturday: boolean
		sunday: boolean
	}
	from: number
	to: number
	activateRuleHours: number
	isForBilling: boolean
	requiresApproval: boolean
	causesCheckFailure: boolean
	useGreatestAmount: boolean
}
export interface GetPBRuleDetailsInterface extends PBRuleDetailsInterface {
	_id: string
}
export interface UpdatePBRuleDetailsInterface extends PBRuleDetailsInterface {
	_id: string
}

export interface HolidayInterface {
	name: string
	date: string
	PBCode: string
	_id?: string
}

export interface CreatePublicHolidaysInterface {
	_id?: string
	name: string
	holiday?: HolidayInterface
}

export interface GetPublicHolidaysInterface {
	_id: string
	name: string
	holidays?: HolidayInterface[]
}

export interface UpdatePublicHolidaysInterface {
	_id: string
	name?: string
	holiday?: HolidayInterface
}

export interface PBTermsInterface {
	name: string
	description: string
}
export interface GetPBTermsInterface extends PBTermsInterface {
	_id: string
}
export interface UpdatePBTermsInterface extends PBTermsInterface {
	_id: string
}

export interface PBTermDetailsInterface {
	PBTerm: string
	startDate: string
	PBCode: string
	dailyOt1Hours: number
	dailyOt2Hours: number
	periodOt1Hours: number
	periodOt2Hours: number
	periodBaseDate: string
	periodDays: number
	restPeriodHours: number
}
export interface GetPBTermDetailsInterface extends PBTermDetailsInterface {
	_id: string
}
export interface UpdatePBTermDetailsInterface extends PBTermDetailsInterface {
	_id: string
}

export interface PayRollTermsInterface {
	_id: string
	name: string
}

export enum PAY_BILL_TABS {
	PB_CODES = "pb_codes",
	PB_TERMS = "pb_terms",
}

export interface PayBillOptions {
	label: string
	component: React.ReactNode
	perform: string | string[]
	featureName: FeatureFlagEnums
	value: PAY_BILL_TABS
}
